import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import App from "../Utils/LayoutMobile";
const NoPageFound = () => {
    const navigate = useNavigate();

    return (
        <App>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
            <Result
                status="404"
                title="404"
                subTitle="Sorry, the page you visited does not exist."
                extra={
                    <Button type="primary" onClick={() => navigate("/")}>
                        Go Back Home
                    </Button>
                }
            />
        </div>
        </App>
    );
};

export default NoPageFound;
